import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export const OrderParking = (props: IconProps = {}): JSX.Element => {
  const { ...rest } = props;

  return (
    <SvgIcon name="OrderParking" {...rest}>
      <path
        d="M21 3V21H3V3H21ZM21 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V21C1 21.5304 1.21071 22.0391 1.58579 22.4142C1.96086 22.7893 2.46957 23 3 23H21C21.5304 23 22.0391 22.7893 22.4142 22.4142C22.7893 22.0391 23 21.5304 23 21V3C23 2.46957 22.7893 1.96086 22.4142 1.58579C22.0391 1.21071 21.5304 1 21 1Z"
        fill="currentColor"
      />
      <path
        d="M12.75 8.88C13.1137 8.91552 13.4488 9.09284 13.6827 9.37357C13.9167 9.6543 14.0306 10.0159 14 10.38C14.028 10.7436 13.9131 11.1037 13.6797 11.3839C13.4462 11.664 13.1127 11.842 12.75 11.88H11V8.88H12.75ZM12.75 6.88H9V13.88H12.75C13.644 13.8436 14.4872 13.4552 15.096 12.7995C15.7048 12.1439 16.0298 11.2742 16 10.38C16.0297 9.48679 15.7045 8.61816 15.0954 7.96412C14.4864 7.31008 13.6431 6.92388 12.75 6.89V6.88Z"
        fill="currentColor"
      />
      <path d="M11 7H9V17.13H11V7Z" fill="currentColor" />
    </SvgIcon>
  );
};
